import * as S from "./MoreInfo.styles";
import { ReactComponent as IconLine } from "../../../styles/assets/svg/icon-line.svg";
import AdvertisingImg from "../../../styles/assets/img/Advertising.png";
import dayjs from "dayjs";
import { formatPrice } from "../../../common/common.fn";

type MoreInfoProps = {
  userTransportData: any;
};

export const MoreInfo = ({ userTransportData }: MoreInfoProps) => {
  console.log("userTransportData", userTransportData);
  return (
    <S.MoreInfo>
      <span>{dayjs(new Date()).format("YYYY년 MM월")} 운송 정보</span>
      <S.MoreContent>
        <S.MoreDetail>
          운송
          <S.MoreValue>
            {userTransportData?.transportationCount === undefined
              ? 0
              : userTransportData?.transportationCount}{" "}
            회
          </S.MoreValue>
        </S.MoreDetail>
        {/* <IconLine />
        <S.MoreDetail>
          배차
          <S.MoreValue>{userTransportData?.transportationCount}회</S.MoreValue>
        </S.MoreDetail> */}
        <IconLine />
        <S.MoreDetail>
          요금
          <S.MoreValue>
            {formatPrice(userTransportData?.totalCostAddFee)} 원
          </S.MoreValue>
        </S.MoreDetail>
      </S.MoreContent>
      {/* <div style={{ width: "100%" }}>
        <img src={AdvertisingImg} alt="Advertising" style={{ width: "100%" }} />
      </div> */}
    </S.MoreInfo>
  );
};
